// Complete replacement for media-gallery.js
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.mql = window.matchMedia('(min-width: 750px)');
      this.prependMedia = this.dataset.disablePrepend !== 'true';
      this.filteringOption = this.dataset.filteringOption;
      this.initialized = false;
    }

    connectedCallback() {
      this.initialize();
      if (!this.initialized) {
        requestAnimationFrame(() => this.initialize());
      }
    }

    initialize() {
      if (this.initialized) return;

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]') ||
          document.querySelector('[id^="GalleryThumbnails"]') ||
          this.querySelector('.thumbnail-list') ||
          document.querySelector('.thumbnail-list')
      };

      if (!this.elements.viewer) return;
      this.initialized = true;

      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      if (this.productInfo && window.Shopify?.postLinksRetry &&
          typeof this.productInfo.initShareLinks === 'function') {
        this.productInfo.initShareLinks();
      }

      this.elements.viewer.addEventListener('slideChanged', (event) => {
        this.onSlideChanged(event);
      });

      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((item) => {
          const button = item.matches('button') ? item : item.querySelector('button');
          if (!button) return;
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.setActiveMedia(item.dataset.target, false);
          });
        });
      }

      if ((this.dataset.desktopLayout || '').includes('thumbnail') && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      const mediaId = event?.detail?.currentElement?.dataset?.mediaId;
      if (!mediaId || !this.elements.thumbnails) return;
      const thumbnail = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'))
        .find((item) => item.dataset.target === mediaId);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend = false, filtering = false, currentVariant = null) {
      const viewer = this.elements?.viewer;
      if (!viewer || !mediaId) return;

      if (filtering && currentVariant && this.filteringOption) {
        this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link')
          .forEach((slide) => {
            const show = slide.dataset.alt === currentVariant[this.filteringOption] ||
              slide.dataset.alt === 'always_display';
            slide.classList.toggle('hidden', !show);
          });
      }

      const activeMedia = Array.from(viewer.querySelectorAll('[data-media-id]'))
        .find((item) => item.dataset.mediaId === String(mediaId));
      if (!activeMedia) return;

      viewer.querySelectorAll('[data-media-id]').forEach((item) => {
        item.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      const thumbnails = this.elements.thumbnails;
      const activeThumbnail = thumbnails
        ? Array.from(thumbnails.querySelectorAll('[data-target]'))
            .find((item) => item.dataset.target === String(mediaId))
        : null;

      if (prepend && this.prependMedia) {
        activeMedia.parentElement?.prepend(activeMedia);
        if (activeThumbnail) activeThumbnail.parentElement?.prepend(activeThumbnail);
        if (typeof viewer.resetPages === 'function') viewer.resetPages();
      }

      this.preventStickyHeader();
      requestAnimationFrame(() => {
        const slider = viewer.slider || activeMedia.parentElement;
        if (slider && typeof slider.scrollTo === 'function') {
          slider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
        }
        if (!thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (typeof viewer.initPages === 'function') viewer.initPages();
        if (typeof viewer.update === 'function') viewer.update();
      }

      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      const thumbnails = this.elements?.thumbnails;
      if (!thumbnails || !thumbnail) return;

      thumbnails.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-current', 'false');
      });
      const button = thumbnail.matches('button') ? thumbnail : thumbnail.querySelector('button');
      button?.setAttribute('aria-current', 'true');

      if (typeof thumbnails.isSlideVisible === 'function' &&
          thumbnails.isSlideVisible(thumbnail, false, 10)) return;

      if (thumbnails.slider && typeof thumbnails.slider.scrollTo === 'function') {
        thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
      }
    }

    announceLiveRegion(activeItem, position) {
      const liveRegion = this.elements?.liveRegion;
      const image = activeItem.querySelector('.product__modal-opener--image img');
      const message = window.accessibilityStrings?.imageAvailable;
      if (!liveRegion || !image || !message) return;

      const announce = () => {
        liveRegion.setAttribute('aria-hidden', 'false');
        liveRegion.textContent = message.replace('[index]', position || '');
        setTimeout(() => liveRegion.setAttribute('aria-hidden', 'true'), 2000);
      };

      if (image.complete) announce();
      else image.addEventListener('load', announce, { once: true });
    }

    playActiveMedia(activeItem) {
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('deferred-media, .deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      }
    }

    preventStickyHeader() {
      const stickyHeader = document.querySelector('sticky-header');
      stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      this.elements.viewer.setAttribute('role', 'presentation');
      this.elements.viewer.querySelectorAll('.product__media-item').forEach((slide) => {
        slide.setAttribute('role', 'presentation');
      });
    }
  });
}